import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import axios from 'axios';

    // // development
    // axios.defaults.authURL = 'http://localhost:50933/';
    // axios.defaults.baseURL = 'http://localhost:56373/';

    // local IIS
    // axios.defaults.authURL = 'https://core0staging.ascendantfx.com/';
    // axios.defaults.baseURL = 'http://localhost:55329/';

    // // Staging
    // axios.defaults.authURL = 'https://core0staging.ascendantfx.com/';
    // axios.defaults.baseURL = 'https://core1staging.ascendantfx.com/';

    // Live
    axios.defaults.authURL = 'https://core0.ascendantfx.com/';
    axios.defaults.baseURL = 'https://core1.ascendantfx.com/';

    
    // 8200
     //  axios.defaults.baseURL = 'http://10.1.11.250:80/AFXCore1_TEST/'; 
    // 8200
    //axios.defaults.baseURL = 'https://core1test.ascendantfx.com/'; 
    
    // Apay demo
    // axios.defaults.baseURL = 'http://10.3.11.172:81/AFXCore1_UAT/'; 
      
    // Live
      //axios.defaults.baseURL = 'https://core1.ascendantfx.com/'; 

    // staging
    // axios.defaults.baseURL = 'https://core1staging.ascendantfx.com/'; 

     //dev
     //axios.defaults.baseURL = 'http://localhost:56372/'; 
    
   // axios.defaults.headers.common['Authorization'] = 'AUTH TOKEN';
    //axios.defaults.headers.post['Content-Type'] = 'application/json';

    // axios.interceptors.request.use(request => {
    //     console.log(request);
    //     // Edit request config
    //     return request;
    // }, error => {
    //     console.log(error);
    //     return Promise.reject(error);
    // });

    // axios.interceptors.response.use(response => {
    //     console.log(response);
    //     // Edit response config
    //     return response;
    // }, error => {
    //     console.log(error);
    //     return Promise.reject(error);
    // });

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
